/** Quiet Signals sequence class names. Named by meaning, not effect. */
export const signal = {
  arrive: "signal-arrive",
  wait: "signal-wait",
  waitCopy: "signal-wait-copy",
  waitEllipsis: "signal-wait-ellipsis",
  confirm: "signal-confirm",
  undo: "signal-undo",
  leave: "signal-leave",
} as const;

export type SignalName = keyof typeof signal;
